<template>
  <div>

    <div class="row carousel-container" :id="'carousel-container' + _uid" :class="{ 'carouselCreated': carouselCreated }">

      <div class="col-12 px-0">
        <div class="carousel-itens">
          <slot></slot>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    name: 'Slider',

    data(){
      return {
        carousel: null,
        carouselCreated: false
      }
    },

    components: {
    },

    props: {
      mode: {
        type: String,
        default: 'carousel'
      },
    },

    methods: {
      carouselControl(direction){
        this.carousel.goTo(direction);
      }
    },

    beforeDestroy() {
      this.carousel.destroy();
    },

    updated(){
      this.carousel.refresh();
    },

    mounted(){
      let _ctx = this;

      this.carousel = this.$carousel({
        // mode: this.mode,
        container: `#carousel-container${this._uid} .carousel-itens`,
        autoWidth: false,
        center: true,
        loop: this.mode == 'gallery',
        items: this.mode == 'carousel' ? 1 : 3,
        slideBy: 1,
        gutter: 20,
        mouseDrag: true,
        controls: this.mode == 'carousel',
        autoplay: this.mode == 'gallery',
        autoplayButtonOutput: false,
        nav: false,
        controlsText: ['', ''],
        onInit: function(){
          _ctx.carouselCreated = true;
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>